import { Playground, Props } from 'docz';
import Component from 'react-component-component';
import { Panel, PanelItem } from "../../../../../src";
import ProductCard from "../../../../../documentation/components/helpers/ProductCard";
import * as React from 'react';
export default {
  Playground,
  Props,
  Component,
  Panel,
  PanelItem,
  ProductCard,
  React
};